<template>
  <div class="">
    <el-dialog
      :title="editData?'编辑':'添加'"
      :append-to-body="true"
       :close-on-click-modal="false"
      :visible.sync="addDialogVisible"
      width="40%"
      :before-close="closeAddViewDialog">
      <div class="description">
        <el-row :span="24">
          <el-col :span="4"><span class="star">*</span>厂商名称:</el-col>
          <el-col :span="19">
             <el-input v-model="roleDetail.roleName" placeholder="请输入厂商名称" clearable class=""></el-input>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="4"><span class="star">*</span>所属区域:</el-col>
          <el-col :span="19">
             <el-input v-model="roleDetail.roleName" placeholder="请输入所属区域" clearable class=""></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- <el-table
        ref=""
        border
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column
          prop="createTime"
          label="模块">
        </el-table-column>
        <el-table-column
          label="权限">
        </el-table-column>
      </el-table> -->

      <span slot="footer" class="dialog-footer">
        <el-button @click="updateOrAddRole(editData?'edit':'add')" size="small" type="primary">{{editData?'修改':'添加'}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object || null
    }
  },
  data () {
    return {
      tableData: [],
      roleDetail: {
        roleName: this.editData ? this.editData.roleName : '',
        remark: this.editData ? this.editData.remark : ''
      }
    }
  },
  created () {
    console.log(this.editData)
  },
  methods: {
    closeAddViewDialog () {
      this.$emit('closeAddViewDialog')
    },
    updateOrAddRole (type) {

    }
  }
}
</script>
<style lang='less' scoped>
.description{
  line-height: 30px;
  .el-col:nth-child(odd){
    text-align: right;
    margin-right: 3%;
  }
  .el-row{
    margin-top: 20px;
  }
}
.title{
  font-weight: bold;
  margin: 10px 0;
  font-weight: bold;
  font-size: 16px;
}
.star{
   color: red;
}
</style>
